import { useUnit } from 'effector-react'
import {
  $dividendList,
  $walletOptions,
  getDividendListFx,
} from 'src/pages/finSystem/balanceSummary/reports/reportDividends/model'

export const useDividendList = () => {
  const dividendList = useUnit($dividendList)
  const loading = useUnit(getDividendListFx.pending)

  return { dividendList, loading }
}

export const useWalletOptions = () => {
  const walletOptions = useUnit($walletOptions)
  const loading = useUnit(getDividendListFx.pending)

  return { walletOptions, loading }
}
